/* Shared launcher. The native theme owns variants, cart writes and checkout. */
(() => {
  if (window.snkrQuickBuyInitialized) return;
  window.snkrQuickBuyInitialized = true;
  let opening = 0;
  const waitForClose = (dialog) =>
    Promise.race([
      Promise.resolve(dialog.hide()),
      new Promise((resolve) => window.setTimeout(resolve, 1200)),
    ]);

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest?.('[data-snkrsmood-quick-buy]');
    if (!trigger || event.defaultPrevented || event.button !== 0 ||
      event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const modal = document.getElementById('SnkrQuickBuy');
    if (!modal || typeof modal.show !== 'function' || !modal.shouleBeShow()) return;

    let url;
    try {
      url = new URL(trigger.getAttribute('href') || trigger.dataset.snkrsmoodQuickBuy, window.location.href);
    } catch (_) {
      return;
    }
    // Only Shopify products on this storefront can be loaded into the dialog.
    if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return;
    event.preventDefault();
    event.stopPropagation();
    const request = ++opening;
    trigger.setAttribute('aria-busy', 'true');
    try {
      // Search / lookbook / cart recommendations may already be in a drawer.
      const parent = trigger.closest(
        'cart-drawer[open],search-drawer[open],drawer-component[open],basic-modal[open],quick-view-modal[open]'
      );
      if (parent && parent !== modal && typeof parent.hide === 'function') await waitForClose(parent);
      if (modal.open) await waitForClose(modal);
      else if (!modal.hidden && modal.hasAttribute('inert')) {
        await Promise.race([
          FoxTheme.utils.waitForEvent(modal, modal.events.handleAfterHide),
          new Promise((resolve) => window.setTimeout(resolve, 1200)),
        ]);
      }
      if (request !== opening || !modal.isConnected) return;
      modal.dataset.productUrl = url.pathname + url.search;
      modal.querySelector('[role="dialog"]')?.setAttribute('aria-label', 'Choisir les options du produit');
      modal.show(trigger.isConnected ? trigger : parent?.activeElement || null);
    } finally {
      trigger.removeAttribute('aria-busy');
    }
  }, true);

  document.addEventListener('quick-view:loaded', () => {
    const modal = document.getElementById('SnkrQuickBuy');
    if (!modal?.open) return;
    const title = modal.querySelector('.product__title,h1,h2');
    if (title) modal.querySelector('[role="dialog"]').setAttribute('aria-label', title.textContent.trim());
  });
})();